
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class SignalInterferenceEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
         const count = Math.floor(20 * (config.parallaxComplexity || 1.0));
        const curTime = time * config.parallaxSpeed;
        const scale = config.parallaxScale || 1.0;

        ctx.strokeStyle = pc.color;
        ctx.lineWidth = 1 * scale;

        const draw = () => {
             ctx.save();
             ctx.globalAlpha *= 0.3 / layerIndex;
            for (let i = 0; i < count; i++) {
                const y = (this.pseudoRandom(i) - 0.5) * height * 2.5;
                const h = 50 * scale * this.pseudoRandom(i + 1);
                
                ctx.beginPath();
                ctx.moveTo(-width * 2, y);
                for (let x = -width * 2; x <= width * 2; x += 20) {
                    const noise = (Math.sin(x * 0.1 + curTime * 5 + i) > 0.8) ? h : 0;
                    ctx.lineTo(x, y + noise);
                }
                ctx.stroke();
            }
            ctx.restore();
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
